import { useLocation, useNavigate } from 'react-router-dom';
import { Home, BarChart3, PlusCircle, User } from 'lucide-react';
import { useAuth } from '../App';

export const BottomNav = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, login } = useAuth();

  const navItems = [
    { path: '/', icon: Home, label: 'Home' },
    { path: '/dashboard', icon: BarChart3, label: 'Rankings' },
    { path: '/submit', icon: PlusCircle, label: 'Submit', requiresAuth: true },
    { path: '/profile', icon: User, label: 'Profile', requiresAuth: true },
  ];

  const handleNavClick = (item) => {
    if (item.requiresAuth && !user) {
      login();
    } else {
      navigate(item.path);
    }
  };

  // Don't show on admin pages
  if (location.pathname.startsWith('/admin')) return null;

  return (
    <nav className="bottom-nav md:hidden">
      {navItems.map((item) => {
        const Icon = item.icon;
        const isActive = location.pathname === item.path;
        
        return (
          <button
            key={item.path}
            onClick={() => handleNavClick(item)}
            className={`bottom-nav-item ${isActive ? 'active' : ''}`}
            data-testid={`bottom-nav-${item.label.toLowerCase()}`}
          >
            <Icon className="bottom-nav-item-icon" />
            <span className="bottom-nav-item-label">{item.label}</span>
          </button>
        );
      })}
    </nav>
  );
};

export default BottomNav;
